<template>
    <b-card>
        <div v-show="!createInvoice">
            <b-alert variant="warning"
                     dismissible
                     :show="!!deletedId"
                     @dismissed="deletedId=null">
                The visit has been deleted.  <a href="#" @click="restoreShift(deletedId)">Click here to undo.</a>
            </b-alert>
            <b-row>
                <b-col>
                    <h4 class="card-title">Unsubmitted Service Visits</h4>

                    <h6 class="text-muted">
                      <span v-show="!client.carrier.invoice_auto_transmit">Please review and approve all service visits to be submitted for reimbursement.</span>
                      <span v-show="client.carrier.invoice_auto_transmit && filteredItems.length > 0">The following service visits will be automatically submitted to {{ client.carrier.name }} on {{ targetedDay }}. In the meantime, you may view, modify and/or delete the visits.</span>
                    </h6>
                </b-col>
            </b-row>
            <div class="table-responsive">
                <b-table hover
                        :sort-by.sync=" sortBy "
                        :sort-desc.sync=" sortDesc "
                         :items="filteredItems"
                         :fields="fields"
                         id="pending-shifts-table"
                         show-empty
                         empty-text="There are no unsubmitted visits eligible for invoicing."
                >

                  <template v-slot:cell(checked_in_time)="row">
                    <utc-time :timezone="row.item.shift_timezone" :time="row.item.checked_in_time" format="MM/DD/YYYY" />
                  </template>
                  <template v-slot:cell(start_time)="row">
                    <utc-time :timezone="row.item.shift_timezone" :time="row.item.start_time" format="hh:mm A" />
                  </template>
                  <template v-slot:cell(checked_out_time)="row">
                    <utc-time :timezone="row.item.shift_timezone" :time="row.item.checked_out_time" format="hh:mm A" />
                  </template>
                  <template v-slot:cell(visit_status)="row">
                    {{ determineVisitStatus(row.item) }}
                  </template>
                  <template v-slot:cell(total)="cost">
                    {{ determineDisplayTotal(row.item) }}
                  </template>

                    <template v-slot:cell(select)="data">
                        <b-form-checkbox :disabled="differentCaregiver(data.item.caregiver_id)" @click="showCaregiverWarning(data.item.caregiver_id)" v-model="selectedShifts" :value="data.item"></b-form-checkbox>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <!--<b-dropdown variant="secondary" text="Menu">-->
                            <!--<b-dropdown-item>Review</b-dropdown-item>-->
                            <!--<b-dropdown-item>Modify</b-dropdown-item>-->
                            <!--<b-dropdown-divider></b-dropdown-divider>-->
                            <!--<b-dropdown-item>Delete</b-dropdown-item>-->
                        <!--</b-dropdown>-->
                        <b-button-group>
                            <b-btn :href="'/client/shifts/' + data.item.id + '?from=invoices'">View</b-btn>
                            <b-btn :href="'/client/shifts/' + data.item.id + '?from=invoices&dispute=1'">Modify</b-btn>
                            <b-btn @click="deleteShift(data.item.id)">Delete</b-btn>
                        </b-button-group>

                    </template>
                </b-table>
            </div>

            <!--<div class="d-flex justify-content-around" v-if="createMode && selectedShifts.length > 0">-->
                <!--<div class="p-2"><strong>Total for Selected Shifts</strong></div>-->
                <!--<div class="p-2"><b>Selected Hours:</b> {{ numberFormat(selectedHours) }}</div>-->
                <!--<div class="p-2"><b>Selected Amount:</b> {{ moneyFormat(selectedAmount) }}</div>-->
                <!--<div class="p-2">-->
                    <!--<b-button variant="success" @click="createInvoice = true">Preview Invoice</b-button>-->
                <!--</div>-->
            <!--</div>-->
        </div>

        <b-row v-if="this.filteredItems.length">
            <b-col>
                <small class="text-muted"><strong>Disclaimer:</strong> {{ fraudWarning }}<br/>
                    <a href="#" @click.prevent="fraudModal = true">View Claims Fraud Warning Statement</a>
                </small>
            </b-col>
            <b-col class="text-right">
                <div class="with-padding-bottom">
                    <b>Total Hours:</b> {{ numberFormat(selectedHours) }}
                    <b>Total Amount:</b> {{ moneyFormat(selectedAmount) }}
                </div>

              <div v-if="client.carrier.invoice_auto_transmit">
                <b-alert show variant="primary">Next Automatic Invoice Submission {{ targetedDay }}</b-alert>
              </div>
              <div v-else>
                <b-button variant="success" size="lg" @click="approvePrompt" :disabled="submitting"><i class="fa fa-spin fa-spinner" v-if="submitting"></i> Approve All Visits and Submit Invoice to {{ carrierName }}</b-button>
              </div>
                <div>
                    <small class="text-muted"><strong>Note:</strong> An individual invoice will be created for each provider for reimbursement purposes.<br/>
                    </small>
                </div>
                <div>

                  <div class="alert alert-warning" role="alert">
                    {{ warningLanguage ? warningLanguage : defaultWarningLanguage }}
                  </div>
                </div>
            </b-col>
        </b-row>

        <claims-fraud-warning-modal v-model="fraudModal" />

        <!--<div v-if="createInvoice">-->
            <!--<b-row>-->
                <!--<b-col><h4 class="card-title">Review and Approve Invoice</h4></b-col>-->
                <!--<b-col class="text-right"><b-button variant="default" @click="createInvoice = false">Go Back</b-button></b-col>-->
            <!--</b-row>-->
            <!--<client-invoice-preview :items="selectedShifts" :initials="client.initials" :fraud-warning="fraudWarning" />-->
        <!--</div>-->


        <b-modal id="incomplete-shifts-warning" ref="incomplete-shifts-warning" title="Attention" size="xl" :ok-disabled="true" :cancel-disabled="true" hide-footer centered>
            <p class="my-4">The following visits require attention and will not be submitted at this time:</p>

            <div>
                <ul>
                    <li v-for="visit in visitsRequiringAttention">
                        {{ formatDate(visit.checked_in_time) }} (Start: {{ formatTime(visit.checked_in_time) }} -- End: {{ formatTime(visit.checked_out_time) }}) from {{ visit.caregiver.name }}
                    </li>
                </ul>
            </div>

            <p class="my-4">Click Continue to submit visits that don't require attention. Click Cancel to review before submitting.</p>

            <div class="actions">
                <b-button size="sm" variant="outline-primary" @click="cancelPrompt">Cancel</b-button>
                <b-button size="sm" variant="success" @click="submitPrompt">Continue</b-button>
            </div>
        </b-modal>

    </b-card>
</template>

<script>
    import { sortBy } from 'lodash';
import FormatsDates from '../../mixins/FormatsDates';
    import FormatsNumbers from '../../mixins/FormatsNumbers';
    import ClientInvoicePreview from "./ClientInvoicePreview";

    export default {
        components: {ClientInvoicePreview},
        props: ['client', 'shifts', 'carrierName', 'carrierAutoSubmit', 'fraudWarning', 'warningLanguage'],

        mixins: [FormatsDates, FormatsNumbers],

        data() {
            return {
                createMode: false,  // Enables selection of shifts
                createInvoice: false,  //  Moves selected shifts to the invoice preview component
                // selectedShifts: [],
                items: this.shifts.map(item => {
                    // Needed for the start time and date being separate
                    item.start_time = item.checked_in_time;
                    let visit_status = "";
                        
                    if (item.shift_in_invoices > 0) {
                        visit_status = "Complete"
                    }

                    if (item.under_24_hours && item.has_adls) {
                        visit_status = "Complete"
                    }

                    if (!item.under_24_hours) {
                        visit_status = "Requires Attention"
                    }

                    if (!item.has_adls) {
                        visit_status = "Requires Attention"
                    }

                    item.visit_status = visit_status

                    return item;
                }),
                fields: [
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    },
                    {
                        key: 'checked_in_time',
                        label: 'Date',
                        // formatter: (value) => this.formatDateFromUTC(value),
                    },
                    {
                        key: 'start_time',
                        label: 'Start',
                        // formatter: (value) => this.formatTimeFromUTC(value),
                    },
                    {
                        key: 'checked_out_time',
                        label: 'End',
                        // formatter: (value) => this.formatTimeFromUTC(value),
                    },
                    {
                        key: 'caregiver',
                        label: 'Provider',
                        formatter: this.getNameFromObj,
                    },
                    {
                        key: 'visit_status',
                        label: 'Visit Status',
                    },
                    {
                        key: 'duration',
                        label: 'Hours',
                        formatter: this.numberFormat,
                    },
                    {
                        key: 'cost',
                        label: 'Total',
                        formatter: (value) => this.moneyFormat(value),
                    },
                ],
                deletedId: null,
                submitting: false,
                fraudModal: false,
                sortBy: 'visit_status',
                sortDesc: true,
                defaultWarningLanguage: 'By approving all visits and submitting this invoice, I certify that to my knowledge all of the service visit information is true and correct. I have read and understand the applicable state fraud warning statement, and understand that civil and/or criminal penalties may be imposed for misrepresentation of information.',
                visitsRequiringAttention: []
            }
        },
        computed: {
            getFormattedOptions() {
              return { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
            },
            targetedDay() {
              if (!this.client.targeted_date) {
                return '';
              }
              const date = new Date(this.client.targeted_date)
              return date.toLocaleDateString('en-US', this.getFormattedOptions);
            },
            filteredItems() {
                return this.items.filter(item => !item.deleted_at);
            },
            selectedShifts() {
                return this.filteredItems;
            },
            selectedHours() {
                return this.selectedShifts.reduce((carry, item) => carry + item.duration, 0);
            },
            selectedAmount() {
                return this.selectedShifts.reduce((carry, item) => carry + item.cost, 0);
            },
            selectedCaregiverId() {
                if (!this.selectedShifts.length) return null;
                return this.selectedShifts[0].caregiver_id;
            }
        },
        methods: {
            weekEnding(data) {
                if (data.item.week) {
                    if ('end' in data.item.week) {
                        return this.formatDate(data.item.week.end);
                    }
                }
                return 'N/A';
            },
            getNameFromObj(object) {
                return object ? object.name : 'N/A';
            },
            differentCaregiver(caregiver_id) {
                return this.selectedCaregiverId && this.selectedCaregiverId !== caregiver_id;
            },
            showCaregiverWarning(caregiver_id) {
                if (this.differentCaregiver(caregiver_id)) {
                    alert('An invoice can only contain shifts from a single provider.');
                }
            },
            async deleteShift(id) {
                if (!confirm('Are you sure you wish to delete this visit record?')) {
                    return;
                }
                const response = await axios.delete('/client/shifts/' + id);
                this.deletedId = id;
                let shift = this.items.find(shift => shift.id === id);
                shift.deleted_at = moment().toDate();
            },
            async restoreShift(id) {
                let form = new Form({});
                const response = await form.post('/client/shifts/' + id + '/restore');
                let shift = this.items.find(shift => shift.id === id);
                this.deletedId = null;
                shift.deleted_at = null;
            },
            async submit() {
                this.submitting = true;

                let form = new Form({
                    shifts: this.selectedShifts.map(item => item.id),
                });

                try {
                    await form.post('/invoice-history');
                } finally {
                    this.submitting = false;
                }
            },
            async approvePrompt() {
                this.visitsRequiringAttention = []

                // If Auto-submit invoices is enabled, just go ahead w/ submit
                if (this.carrierAutoSubmit) {
                    console.log("Carrier is auto-submit on, just send them.")
                    this.$refs['incomplete-shifts-warning'].hide()
                    this.submit()
                }

                // Check if there are invoices with a visit status of "Requires Attention"
                console.log("Listing visits that must be confirmed...")
                this.shifts.forEach((element) => {
                    if (element.visit_status.includes("Requires Attention")) {
                        this.visitsRequiringAttention.push(element)
                    }
                })

                if (this.visitsRequiringAttention.length > 0) {
                    this.$refs['incomplete-shifts-warning'].show()
                } else {
                    console.log("No such invoices fall under the criteria, we can submit safely.")
                    this.submit()
                }
            },
            async submitPrompt() {
                this.$refs['incomplete-shifts-warning'].hide()

                this.submitting = true;
                let activeShifts = this.selectedShifts
                
                console.debug("selectedShifts()", this.selectedShifts);
                console.debug("activeShifts", activeShifts);

                let validShifts = []
                this.selectedShifts.forEach((shift) => {
                    if (shift.visit_status === "Complete") {
                        validShifts.push(shift.id)
                    }
                });

                let form = new Form({
                    shifts: validShifts
                }) 

                if (form.shifts.length > 0) {                    
                    try {
                        await form.post('/invoice-history')
                    } finally {
                        this.submitting = false
                    }
                } else {
                    alert('There are no valid invoices to submit.');
                    this.submitting = false;
                }
            },

            determineVisitStatus(item) {
                //console.debug("determineVisitStatus", item)

                if (item.shift_in_invoices > 0) {
                    return "Complete"
                }

                if (item.under_24_hours && item.has_adls) {
                    return "Complete"
                }

                if (!item.under_24_hours) {
                    return "Requires Attention"
                }

                if (!item.has_adls) {
                    return "Requires Attention"
                }

                return "Complete"
            },

            determineDisplayTotal(item) {
                let visit_total = 0.00;

                if (item.shift_in_invoices > 0) {
                    visit_total = item.visit_total;
                } else if (!item.has_adls) {
                    visit_total = 0
                } else if (!item.under_24_hours) {
                    visit_total = 0
                } else {
                    visit_total = item.visit_total
                }

                return this.moneyFormat(visit_total)
            },

            cancelPrompt() {
                this.$refs['incomplete-shifts-warning'].hide()
            }
        },
        watch: {
            createMode(val) {
                if (val) {
                    this.fields.unshift('select');
                }
            },
        }
    }
</script>
<style scoped>
    .actions {
        display: flex; 
        flex-wrap: wrap; 
        align-items: center; 
        justify-content: flex-end; 
        padding: .75rem;
    }
    .actions > button {
        margin: 0 .25rem;
    }
</style>